import useThrottle from './use-throttle';
import { toast } from 'react-toastify';

const useCopyText = () => {
  const copyToClipboard = (textToCopy, textSuccess) => {
    navigator.clipboard.writeText(textToCopy);
    toast.success(textSuccess);
  };

  return useThrottle((textToCopy, textSuccess) => copyToClipboard(textToCopy, textSuccess), 3000);
};

export default useCopyText;
